module.exports = __webpack_public_path__ + "img/truck.5e1b61b3.svg";